import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addNew: {
    id: 'components.autocomplete.addNew',
    defaultMessage: 'Add new',
  },
  search: {
    id: 'components.autocomplete.search',
    defaultMessage: 'Search...',
  },
  select: {
    id: 'components.autocomplete.select',
    defaultMessage: 'Select',
  },
});

export default messages;
